import React from 'react';

import Box from '../Box';
import { Wrapper } from "./ACommonStyles";
import { styled } from "../../../stitches.config";
import { getPcsUrls } from "./AHelpers";

export default props => {
	const pcs = getPcsUrls(props.settings.settings?.pcs_background_mobile, props.settings.settings?.pcs_background_desktop);

	return (
		<Section className="container" data-tb-region={props.blockSettings.tb_region}>
			<Wrapper className="row" pcs={pcs}>
				<div className="col-xs-12 col-md-6">
					<Box {...props} id="b1" type="BPhotoOnTop" size="lg" settings={props.settings.b1} classes="" />
				</div>
				<div className="col-xs-12 col-md-6">
					<Box {...props} id="b2" type="BPhotoOnTop" size="lg" settings={props.settings.b2} classes="" />
				</div>
			</Wrapper>
		</Section>
	);
}

const Section = styled("section", {
	marginBottom: '40px'
})
